import { Grid, Heading } from '@zappyrent/hundop';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import PressReferences from '../LogoShowcase';
import { StyledHeadingWrapper, StyledWrapper } from './TalkingAboutUs.styles';

const TalkingAboutUs = (): JSX.Element => {
  const { t } = useTranslation('product');

  return (
    <StyledWrapper>
      <StyledHeadingWrapper>
        <Grid container>
          <Heading
            tag="h1"
            sm="24px"
            md="24px"
            lg="24px"
            charSpacing="-0.48px"
            variant="secondary"
          >
            <Trans i18nKey="talkingAboutUs" t={t} />
          </Heading>
        </Grid>
      </StyledHeadingWrapper>

      <PressReferences />
    </StyledWrapper>
  );
};

export default TalkingAboutUs;
